export default "__VITE_ASSET__BJxxMXbE__"